import { render } from "./SDV_VerificationModal.vue?vue&type=template&id=3cb3b733&scoped=true"
import script from "./SDV_VerificationModal.js?vue&type=script&lang=js"
export * from "./SDV_VerificationModal.js?vue&type=script&lang=js"

import "./SDV_VerificationModal.vue?vue&type=style&index=0&id=3cb3b733&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb3b733"]])

export default __exports__